import Model from './Model'

export default class Item extends Model {
  id: number
  value: string
  updatedAt: string
  imagePath: string
  informations: []

  constructor(item, locale) {
    super({})

    this.id = item.id
    this.value = item.value
    this.updatedAt = item.updated_at

    this.imagePath = item._preview_picture ? item._preview_picture._picture.path : this.imagePath
    this.imagePath = item._picture ? item._picture.path : this.imagePath
    this.informations = item.infos.map((info) => {
      return {
        title: this.translateField(info._title, locale),
        fieldName: info.name,
        value: info.value
      }
    })
  }
}
